<template>
  <div class="featurDetial">
    <detail-banner v-if="featureInfo != null" :featureInfo="featureInfo" />
    <IconGroup></IconGroup>
    <!-- <img-group v-if="featureInfo != null"  :featureInfo='featureInfo' @showWxFn='isShowWx = true' /> -->
    <Detail-Txt v-if="featureInfo != null" :featureInfo="featureInfo" />
    <LiveInstance
      v-if="featureInfo"
      :liveAddress="featureInfo.liveAddress"
      :featureInfo="featureInfo"
    ></LiveInstance>
    <!-- <FeatureTabs @selectType='selectTypeFn'></FeatureTabs> -->
    <template v-for="(item, index) in postList">
      <DetialList :key="index" :itemData="item"></DetialList>
    </template>
    <back-top></back-top>

    <div class="weixin_box" v-if="isShowWx" @click="isShowWx = false">
      <img
        class="hint_img"
        src="https://www.shanghaieye.cn/wp-content/plugins/asian-social-share/images/wechat.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import DetailBanner from "./featureDetailChild/DetailBanner.vue";
import ImgGroup from "./featureDetailChild/ImgGroup.vue";
import DetailTxt from "./featureDetailChild/DetailTxt.vue";
import LiveInstance from "./featureDetailChild/LiveInstance.vue";
// import FeatureTabs from "./featureDetailChild/FeatureTabs.vue";
import DetialList from "./featureDetailChild/DetialList.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";
import IconGroup from "./featureDetailChild/IconGroup.vue";

import { getFeatureDetails, getPreviewFeature } from "@/network/details.js";

export default {
  name: "FeatureDetail",
  components: {
    DetailBanner,
    ImgGroup,
    DetailTxt,
    LiveInstance,
    // FeatureTabs,
    DetialList,
    BackTop,
    IconGroup,
  },
  data() {
    return {
      featureId: "",
      featureInfo: "",
      postList: [],
      page: 1,
      loading: true,
      realArr: "",
      type: "All",
      isShowWx: false,
    };
  },
  created() {
    this.getSendData();
  },
  mounted() {
    this.featureId = this.$route.query.featureId;
    this.getFeatureFn();
    document.addEventListener("scroll", this.loadMore);
    //获取预览信息
    this.getPreviewFeature();
    this.initFB();
  },
  destroyed() {
    // console.log('destroyed')
    document.removeEventListener("scroll", this.loadMore);
  },
  methods: {
    initFB() {
      window.fbAsyncInit = function() {
        FB.init({
          appId: "922247491571970",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v7.0",
        });
      };
    },

    getPreviewFeature() {
      var featureId = localStorage.getItem("featureId");
      // console.log(featureId)
      // console.log(this.featureId, "this.feaid");
      if (featureId) {
        getPreviewFeature({ featureId: featureId }).then((res) => {
          if (res.code == 200) {
            // console.log(res);
            this.featureInfo = res.data.featureInfo;
            // console.log(this.featureInfo)
            this.postList = this.postList.concat(res.data.posts);
          }
        });
      }
    },
    getSendData() {
      let self = this;
      this.$nextTick(() => {
        window.addEventListener(
          "message",
          function(event) {
            if (event.data.featureId) {
              this.realArr = event.data.featureId;
              // console.log(this.realArr)
              let idx = {};
              idx.featureId = this.realArr;
              localStorage.setItem("featureId", this.realArr);
              self.getPreviewFeature();
            }
          },
          false
        );
      });
    },

    //滚动到底部加载更多
    load() {
      if (this.loading) {
        this.loading = false;
        setTimeout(() => {
          this.page++;
          this.getFeatureFn();
        }, 500);
      }
    },
    //触发滚动
    loadMore() {
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
      let nowScotop =
        document.documentElement.clientHeight || document.body.clientHeight; //可视区高度
      let wheight =
        document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度

      if (this.loading) {
        if (nowScotop >= scrollHeight - wheight - 5) {
          setTimeout(() => {
            this.load(); //加载列表的请求方法
          }, 500);
        }
      }
    },
    getFeatureFn() {
      // 预览接口下拉请求数据featureid为空情况从localStorage取值
      var featureId = localStorage.getItem("featureId");
      if (featureId) {
        this.featureId = featureId;
      }
      let tempObj = {
        featureId: this.featureId,
        page: this.page,
        size: 10,
      };
      if (this.type !== "All") {
        tempObj.type = this.type;
      }
      getFeatureDetails(tempObj)
        .then((res) => {
          // console.log(res)
          this.featureInfo = res.data.featureInfo;
          document.querySelector('meta[property="og:title"]').content =
            this.featureInfo?.featureName + " | ShanghaiEye";
          document.querySelector('meta[property="og:description"]').content =
            this.featureInfo?.featureName + " | ShanghaiEye";
          if (this.featureInfo.featureImgUrl) {
            document.querySelector('meta[property="og:image"]').content =
              "https://www.shanghaieye.cn" + this.featureInfo.featureImgUrl;
          }
          document.title = res.data.featureInfo.featureName + " | ShanghaiEye";
          this.postList = this.postList.concat(res.data.posts);
          this.loading = true;
        })
        .catch((res) => {
          this.loading = true;
        });
    },
    selectTypeFn(id) {
      if (id == 1) {
        this.type = "all";
      }
      if (id == 2) {
        this.type = "news";
      }
      if (id == 3) {
        this.type = "video";
      }
      this.page = 1;
      this.postList = [];
      this.getFeatureFn();
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .featurDetial {
    padding: 0 18%;
  }
}

.weixin_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 6666;

  .hint_img {
    // width: 100%;
    // max-width:400px;
    height: 100vh;
    margin: 0 auto;
    display: block;
  }
}
</style>
